import styled from 'styled-components';

export default styled.div`
  max-width: 1024px;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin: auto;
  @media ${(p) => p.theme.sm} {
    padding: 15px;
  }
`;
